var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.266515 0.26308C-0.0888383 0.612347 -0.0888383 1.17655 0.266515 1.52581L3.80182 5.00056L0.266515 8.47532C-0.0888383 8.82458 -0.0888383 9.38878 0.266515 9.73805C0.621868 10.0873 1.1959 10.0873 1.55125 9.73805L5.73349 5.62745C6.08884 5.27819 6.08884 4.71399 5.73349 4.36472L1.55125 0.254124C1.20501 -0.0861863 0.621868 -0.0861861 0.266515 0.26308Z",
    fill: "#5BB3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/rightChevron.c5088685ae48ed2b078833077a43fb6b.svg";
export { ForwardRef as ReactComponent };